/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Model from '@tripian/model';
import CloseIconButton from '../base/Button/Icons/CloseIconButton/CloseIconButton';
import classes from './AccommondationInfo.scss';
import { MapPin, Home } from '../base/Svg/Icons';

interface IAccommondationInfo {
  accommodation: Model.Accommodation;
  close: (accommodation: Model.Accommodation) => void;
  t: (value: Model.TranslationKey) => string;
}

const AccommondationInfo: React.FC<IAccommondationInfo> = ({ accommodation, close, t }) => {
  const [copySuccess, setCopySuccess] = useState('');

  const copyToClipBoard = async (copyMe: string | null) => {
    if (copyMe === null) return;
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess(t('trips.myTrips.itinerary.step.poi.address.copied'));
      setTimeout(() => {
        setCopySuccess('');
      }, 1000);
    } catch (err) {
      setCopySuccess(t('trips.myTrips.itinerary.step.poi.address.failed'));
    }
  };

  return (
    <div className={classes.accommodationContainer}>
      <div className={classes.closeButton}>
        <CloseIconButton className="w-6 h-6" fill="#696969" clicked={() => close(accommodation)} />
      </div>

      <div className={classes.accommodationInfo}>
        <div className={classes.header}>
          <h1 className={classes.title}>{accommodation.name}</h1>
        </div>

        <div className={classes.content}>
          <div className={classes.gallery}>
            {accommodation.imageUrl && accommodation.imageUrl !== '' ? (
              <img className={classes.accommodationImg} alt={accommodation.provider ?? ''} src={accommodation.imageUrl} referrerPolicy="no-referrer" />
            ) : (
              <div className={classes.homeIcon}>
                <Home size="4rem" />
              </div>
            )}
          </div>
        </div>
        {accommodation.address && <div className={classes.divider} />}
        <div className={classes.contactInfo}>
          {accommodation.address && (
            <div className={classes.infoItem}>
              <MapPin width="16" height="16" className={classes.icon} />
              <div className={classes.content}>
                <div className={classes.label}>{t('trips.myTrips.itinerary.step.poi.address.title')}</div>
                <div className={classes.value} role="button" tabIndex={0} onClick={() => copyToClipBoard(accommodation.address)} onKeyPress={() => {}}>
                  {copySuccess || accommodation.address}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccommondationInfo;
